import { StarIcon } from '@heroicons/react/24/solid'
import { TruckInformationFragment } from 'components/HeroSection/types/TruckInformationFragment'
import { formatRatingsCount } from 'utils/formatRatingsCount'

const Rating = ({
  ratingInfo
}: {
  ratingInfo: TruckInformationFragment['ratingInfo']
}) => {
  if (!ratingInfo) return null
  if (ratingInfo.ratingsCount <= 0) return null

  return (
    <div className="mt-3 italic text-white flex items-center">
      <StarIcon className="w-6 h-6 mr-2 text-orange-400" />
      <p className="mr-2">{ratingInfo.averageRating}</p>
      {ratingInfo.ratings.length > 0 && (
        <a
          className="underline"
          href="#ratings"
          onClick={(e) => {
            e.preventDefault()
            document.querySelector('#ratings')?.scrollIntoView({
              behavior: 'smooth'
            })
          }}
        >
          <p>({formatRatingsCount(ratingInfo.ratingsCount)})</p>
        </a>
      )}
    </div>
  )
}

export default Rating
